<div class="grower-add-sec editPage dealer-order-add">
  <div>
    <div class="search-box-inner">
      <form name="" action="">
        Order Details
        <i class="fas fa-angle-down" aria-hidden="true"></i>
        <span class="float-r">
          <i class="fas fa-ellipsis-v"></i>
        </span>
      </form>
    </div>
  </div>
  <div class="grower-order-info">
    <div class="row grower-info-sec dealer-info">
      <div class="col-12 col-lg-4 border-dashed">
        <div class="grower-hover" [ngClass]="{'grower-info-hover': showAccInfo === true}">
          <div class="row">
            <div class="col-4">Account: </div>
            <div class="col-8 text-md-right text-left info-value">
              <span>
                {{selAccountObj?.accountNumber}} - {{selAccountObj?.accountName}}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Address: </div>
            <div class="col-8 text-md-right text-left info-value">{{selAccountObj?.address1}} {{selAccountObj?.city}}, {{selAccountObj?.state}} {{selAccountObj?.zipCode}}</div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="row">
          <div class="col-4">
            Last Updated:
          </div>
          <div class="col-8 info-value text-md-right text-left">
            <span>{{dealerOrderData?.updateTimestamp | date:'MMMM dd, yyyy'}}</span>
          </div>
        </div>
      </div>

      <!-- AC4: Removed Display Early Advantage Units checkbox filter from the Dealer Order screen
      <div *ngIf="isEaUnitsEligible" class="col-12 col-lg-4 text-left text-md-right d-none d-md-block">
        <span class="padding-t20 padding-md-t0">Display Early Advantage Units</span>
        <mat-checkbox class="custom-checkbox margin-l10"
                      #getZeroEaQtyRecords
                      [checked]="ignoreZeroEaUnitRecords"
                      (change)="filterEADealerOrderDetail(getZeroEaQtyRecords._checked)"
                      title="Display Early Advantage Units"></mat-checkbox>
      </div>
      -->
    </div>
    <div class="growerIdOuter padding-t0 padding-b0" *ngIf="isSubscriptionAccess">
      <div class="row">
        <div class="col-12 col-md-3 m-auto margin-l0">
          <div class="row">
            <div class="col-4">
              Dealer Order#:
            </div>
            <div class="col-8 grower-order-no">
              <span>{{dealerOrderData?.orderNumber}}</span>
            </div>
          </div>
          <!--<span class="grower-order-no display-ib padding-t20 padding-l0">
          Dealer Order# : {{dealerOrderData?.orderNumber}}
        </span>-->
        </div>
        <div class="col-12 col-md-4 pr-0">
          <div class="row">
            <div class="col-4">
              <span class="customer-po display-ib padding-t20 padding-l2">
                Non-Subscriber Email:
              </span>
            </div>
            <div class="col-8 p-0">
              <mat-form-field class="example-full-width m-0" style="width: 114%;" [ngClass]="{valid : (isNotValid ==false)}">
                <input matInput type="email" name="accountEmail"
                       [(ngModel)]="accountEmail"
                       [pattern]="emailPattern"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [readonly]="accessTypeMode"
                       (keyup)="validateEmail()"
                       email="true"
                       #emailField="ngModel">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 orderQuantity text-left text-md-right">
          <span class="padding-t20 padding-md-t0">Display product with dealer order quantity > 0</span>
          <mat-checkbox class="custom-checkbox margin-l10"
                        #getZeroQtyRecords
                        [checked]="ignoreZeroQtyRecords"
                        (change)="filterDealerOrderDetail(getZeroQtyRecords._checked)"
                        title="Display product with dealer order quantity > 0"></mat-checkbox>
        </div>
      </div>
    </div>

    <div class="order-top-sec">
      <div class="row listing-action-items grower-page">
        <div class="col-12 col-md-8">
          <div class="row">
            <div class="" [ngClass]="selectedCount>0 && isSearchClicked ? 'col-11':'col-12'">
              <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                            [checked]="selectedCount > 0"
                            [style.display]="disablecheckbox || isReadOnly || accessTypeMode ? 'none' : 'block'"
                            [indeterminate]="dealerOrderDSLength > 0 && selectedCount > 0 && selectedCount < dealerOrderDSLength"
                            (change)="EnableAllEditToolKit(Allcheck._checked)"
                            title="Select All Lines"></mat-checkbox>
              <!--<i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>-->
              <div class="product-filter-outer margin-sm-l25">
                <div class="product-filter col-md-12" *ngIf="!editToolKit || selectedCount<=0 || isSearchClicked">
                  <div class="search-category">
                    <div class="brand-dropdown default-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="productSearchFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="name"
                                 bindValue="value"
                                 [searchable]="false"
                                 (change)="keepFilter()"
                                 placeholder="Select Category">
                      </ng-select>
                    </div>
                  </div>
                  <div class="search-box">
                    <div class="row margin-0">
                      <div class="default-select select-container">
                        <div *ngIf="productSearchFilter === 'ProductNameFilter'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="selectProductName($event)" (blur)="selectProductName($event)" [(ngModel)]="productFilters.ProductNameFilter" placeholder="Search Order">
                            </div>
                          </div>
                        </div>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                   [items]="marketingMasterList"
                                   placeholder="Search Order"
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.MarketingBrandList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'seedSize'"
                                   [items]="seedsizeMasterList"
                                   placeholder="Search Order"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   class="custom-select-grower"
                                   [(ngModel)]="productFilters.SeedSizeList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'packageSize'"
                                   [items]="packagesizeMasterList"
                                   placeholder="Search Order"
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.PackageSizeList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <div *ngIf="productSearchFilter === 'technology'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="selectTechnology($event)" (blur)="selectTechnology($event)" [(ngModel)]="productFilters.TechnologyList" placeholder="Search Order">
                            </div>
                          </div>
                        </div>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'treatment'"
                                   [items]="treatmentMasterList"
                                   placeholder="Search Order"
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.TreatmentList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'productLine'"
                                   [items]="productLineMasterList"
                                   placeholder="Search Order"
                                   class="custom-select-grower"
                                   [multiple]="true"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.ProductLineList"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        <!--<div class="col-md-6 maturitySelect" *ngIf="productSearchFilter === 'maturity'">
                        <ng-select #productSearch name="ddlproductSearch"
                                   [items]="maturityMasterList"
                                   placeholder="Min"
                                   class="custom-select-grower "
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.MaturityMin"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="col-md-6 maturitySelect" *ngIf="productSearchFilter === 'maturity'">
                        <ng-select #productSearch name="ddlproductSearch"
                                   [items]="maturityMasterList"
                                   placeholder="Max"
                                   class="custom-select-grower"
                                   [hideSelected]="true"
                                   [(ngModel)]="productFilters.MaturityMax"
                                   [virtualScroll]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   [closeOnSelect]="true"
                                   [searchFn]="filterSearchFn"
                                   (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>-->
                      </div>
                      <!--<form name="" action="">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup)="applyFilterData($event.target.value)" placeholder="Filter Products...">
                      </div>
                    </form>-->
                    </div>
                  </div>
                </div>
                <div class="row chips-sec" *ngIf="(!editToolKit || selectedCount<=0  || isSearchClicked) && filterValueList != ''">
                  <div class="col-9 selected-chip">
                    <div>
                      <mat-chip-set>
                        <mat-chip selected *ngFor="let filterValue of filterValueList">
                          {{filterValue}}
                          <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                            <i class="fas fa-times text-right"></i>
                          </a>
                        </mat-chip>
                      </mat-chip-set>
                    </div>
                  </div>
                  <div class="col-3 text-right" *ngIf="filterValueList.length > 0">
                    <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                  </div>
                </div>
              </div>
              <div class="product-tools-tab position-sm-relative" *ngIf="(selectedCount>0) && (!isSearchClicked && editToolKit)" appClickOutside (clickOutside)="tabNode=''">
                <div class="tab-bar">
                  <ul>
                    <li (click)="showTab('banned')" [ngClass]="{'active': tabNode==='banned'}" class="seperator margin-sm-r5 d-none d-lg-block" matTooltip="Modify Product" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      <i class="icon-ico-replace"></i>
                    </li>
                    <li (click)="openDealerOrderTransferSliderModel()" class="seperator margin-sm-r5 d-none d-lg-block" matTooltip="Transfer Product" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      <i class="icon-ico-transfer"></i>
                    </li>
                    <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator margin-sm-r5" matTooltip="Set Order Quantity to Zero" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      <i class="icon-ico-trash"></i>
                    </li>
                    <li *ngIf="selectedCount>0 && isSearchClicked==false" (click)="isSearchClicked=true;" class="seperator" matTooltip="Search your order" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      <i class="icon-ico-Search"></i>
                    </li>
                    <li *ngIf="isInternalTransfer" (click)="openInternalOrderTransferSliderModel()" class="seperator bgTale  margin-sm-l5 d-none d-lg-block" matTooltip="Transfer Outside Territory" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                      <i style="position:relative; top: -2px;" class="fas fa-exchange-alt margin-l0"></i>
                    </li>
                    <!-- AC2: Removed EA button from the edit line function of the Dealer Order screen
                    <li *ngIf="isEaUnitsEligible && isEaUnitsExist && (isEaSwapEligible || isEaDecreaseEligible || isEaModifyEligible)" (click)="showTab('showEaOptions')"
                        [ngClass]="{'active': tabNode==='showEaOptions'}" class="seperator margin-sm-r5 d-none d-lg-block">
                      <span style="position:relative; top: -2px;" class="margin-l0">EA</span>
                    </li>
                    -->
                    <!--<li *ngIf="selectedCount>0" (click)="isSearchClicked=true;">
                    <i class="icon-ico-Search"></i>
                  </li>
                  <li *ngIf="selectedCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                    <i class="icon-ico-Close"></i>
                  </li>-->
                  </ul>
                </div>
                <div class="tab-content">
                  <div *ngIf="tabNode==='delete'" class="delete-product">
                    <div class="tab-content-heading">
                      For: {{selAccountObj?.accountName}}
                    </div>
                    <div class="tab-content-detail">
                      <p>Are you sure you want to set order quantity to zero for <span> {{selectedCount}} </span> selected Items(s)?</p>
                      <div class="btn-area">
                        <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                        <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="tabNode==='banned'">
                    <div class="tab-content-heading">
                      For: {{selAccountObj?.accountName}}
                    </div>
                    <div class="tab-content-detail">
                      <div class="btn-area">
                        <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="openModifyItem('PackageSize')">Package Size</button>
                        <button mat-raised-button class="btns normal-large-btn margin-l10 margin-sm-l0 margin-r10" color="primary" (click)="openModifyItem('SeedSize')">Seed Size</button>
                        <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="openModifyItem('Treatment')">Treatment</button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="tabNode==='showEaOptions'">
                    <div class="tab-content-heading">
                      For: {{selAccountObj?.accountName}}
                    </div>
                    <div class="tab-content-detail">
                      <div class="btn-area">
                        <button mat-raised-button *ngIf="isEaUnitsEligible && isEaSwapEligible" class="btns normal-large-btn" color="primary" (click)="openEASwapProduct()">Swap EA Product</button>
                        <button mat-raised-button *ngIf="isEaUnitsEligible && isEaDecreaseEligible" class="btns normal-large-btn margin-l10 margin-sm-l0 margin-r10" color="primary" (click)="openModifyDecreaseUnit('Decrease')">Decrease EA Units</button>
                        <button mat-raised-button *ngIf="isEaUnitsEligible && isEaModifyEligible" class="btns normal-large-btn margin-l10 margin-sm-l0 margin-r10" color="primary" (click)="openModifyDecreaseUnit('Modify')">Modify EA Units</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1 margin-l-8">
              <div class="">
                <ul class="padding-t10">
                  <li *ngIf="selectedCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                    <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!--
        <div class="col-12 col-md-2 text-right  d-none d-md-block">
          <div *ngIf="isEaUnitsEligible && isEaAddProductEligible">
            <button mat-raised-button class="btns wide100" [style.display]="isReadOnly || accessTypeMode ? 'none' : 'inline-block'" color="primary" (click)="openAddEAProduct()">Add EA Product</button>
          </div>
        </div>
        -->

        <!-- *ngIf="isAddProductAccess" -->
        <div class="col-12 col-md-4 d-flex justify-content-end">
          <div class="">
            <button mat-raised-button class="btns wide100" [style.display]="isReadOnly || accessTypeMode ? 'none' : 'inline-block'" color="primary" (click)="openAddItem()">Add Product</button>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-md-12">
          <div class="tableContainer">
            <table mat-table [dataSource]="dealerOrderDS" multiTemplateDataRows class="matTables addDealerMobile">

              <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
                <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxArea">&nbsp;</th>
          </div>
          <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="productName text-left">Product</th></div>
          <div *ngIf="column=='seedSize'"><th mat-header-cell *matHeaderCellDef class="seedSize text-center">Seed Size</th></div>
          <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
          <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="packageSize text-center">Package Size</th></div>
          <div *ngIf="column=='technology'"><th mat-header-cell *matHeaderCellDef class="technology text-center">Technology</th></div>
          <div *ngIf="column=='availableUnit'"><th mat-header-cell *matHeaderCellDef class="availableUnit text-center">Available Units</th></div>
          <div *ngIf="column=='longShort'"><th mat-header-cell *matHeaderCellDef class="longShortHead text-center">Long/(Short)</th></div>
          <div *ngIf="column=='dealerBucket'"><th mat-header-cell *matHeaderCellDef class="dealerBucket text-center">My Dealer Bucket</th></div>
          <!--
          <div *ngIf="column=='eaUnits'"><th mat-header-cell *matHeaderCellDef class="availableUnit text-center">EA Units</th></div>
          -->
          <div *ngIf="column=='dealerUnit'"><th mat-header-cell *matHeaderCellDef class="dealerUnit text-center">Dealer Order Units</th></div>
          <td mat-cell *matCellDef="let element" (click)="showItemDetails($event, element, column)">

            <!--(mouseover)="showProdDetails($event, element,column)" (mouseout)="hideProdDetails($event, element,column)"-->
            <div *ngIf="column=='checkbox'" class="text-center product-row-check" title="Select Line">
              <mat-checkbox #SingleCheck class="custom-checkbox"
                            [style.display]="(element.isProductDeactivated === true && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() != 'partial')) || element.dealerUnits < 0 ? 'none' : 'inline-block'"
                            [disabled]="isReadOnly || accessTypeMode"
                            (change)="activeEditToolKit(SingleCheck._checked)"
                            [(ngModel)]="element.isSelected"></mat-checkbox>

              <div class="unavailable-block-Sec" *ngIf="element.dealerUnits < 0; else elseBlock">
                <div id="main_{{element.rowId}}" class="unavailable-block-outer">
                  <span class="unavailable-block">
                    <i class="icon-ico-Banned_Circle handCursor" (mouseover)="blockHideShow(element.rowId, true)" (mouseout)="blockHideShow(element.rowId, false)"></i>
                  </span>
                  <div class="unavail-content" id="sub_{{element.rowId}}">
                    <h4>Please contact Winfield United Customer Service Team #855-494-6343.</h4>
                  </div>
                </div>
              </div>
              <ng-template #elseBlock>
                <div class="unavailable-block-Sec" *ngIf="(element.isProductDeactivated && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() != 'partial'))">
                  <div id="main_{{element.rowId}}" class="unavailable-block-outer">
                    <span class="unavailable-block">
                      <i class="icon-ico-Banned_Circle handCursor" (mouseover)="blockHideShow(element.rowId, true)" (mouseout)="blockHideShow(element.rowId, false)"></i>
                    </span>
                    <div class="unavail-content" id="sub_{{element.rowId}}">
                      <h4>This item is currently unavailable for ordering.</h4>
                    </div>
                  </div>
                </div>
                <div class="unavailable-block-Sec partial-item-msg" id="outer_{{element.rowId}}" *ngIf="element.isProductDeactivated && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'partial' && element.dealerUnits == element.originalDealerUnits)">
                  <div id="main_{{element.rowId}}" class="unavailable-block-outer">
                    <div class="unavail-content" id="sub_{{element.rowId}}">
                      <h4>This item is currently unavailable for ordering.</h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
            <div *ngIf="column=='product'" class="order-info" [attr.data-testid]="element.itemNumber">
              <div class="row">
                <div class="col-md-11 padding-l5" matTooltip="{{element.brand}} - {{element.marketingBrand}} #{{element.itemNumber}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                  <div class="d-block d-md-none">Product</div>
                  <div class="bold">
                    {{element.brand}} - {{element.marketingBrand}}
                  </div>
                  <div class="bold d-block d-md-none">{{element.itemDescription}}</div>
                  <div *ngIf="element.seedNonReturnable" class="bold d-block nonReturnable">*NON-RETURNABLE</div>
                </div>
              </div>
            </div>

            <div *ngIf="column=='seedSize'" class="order-info text-center">
              <div class="row">
                <div class="col-md-11 padding-l10">
                  <div class="bold text-center">{{element.seedSize}}</div>
                </div>
              </div>
            </div>
            <div *ngIf="column=='treatment'" class="order-info text-center">
              <div class="row">
                <div class="col-md-11 padding-l20">
                  <span [ngClass]="{'oval-shape treatment': (element.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                    <strong>{{element.treatment}}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="column=='packageSize'" class="order-info text-center">
              <div class="row">
                <div class="col-md-11 padding-l15">
                  <span [ngClass]="{'oval-shape pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                    <strong>{{element.packageSize}}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="column=='technology'" class="order-info text-center">
              <div class="row">
                <div class="col-md-11 padding-l15">
                  <span [ngClass]="{'oval-shape technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                    <strong>{{element.technology}}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="column=='availableUnit'" class="text-center unitsText">
              <div class="d-block d-md-none padding-l5">Available Units</div>
              <div>
                {{element.seedAvailability | number}}
              </div>
            </div>
            <div *ngIf="column=='longShort'" class="text-center unitsText">
              <div class="d-block d-md-none padding-l5">Long/(Short)</div>
              <div>
                <span *ngIf="element.longShortPosition>=0">{{commonService.getFormatedNumber(element.longShortPosition) | number}}</span>
                <span class="oval-shape treatment" *ngIf="element.longShortPosition<0"> ({{commonService.getFormatedNumber(element.longShortPosition | positiveValue) | number}})</span>
              </div>
            </div>
            <div *ngIf="column=='dealerBucket'" class="text-center unitsText">
              <div class="d-block d-md-none padding-l5">My Dealer Bucket</div>
              <div>
                <span *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                <span *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
              </div>
            </div>
            <!-- AC1: Removed EA Units column cell from the Dealer Order screen
            <div *ngIf="column=='eaUnits'" class="text-center unitsText eaUnitsColumn">
              <div class="d-block d-md-none padding-l5">EA Units</div>
              <div>
                <span>{{commonService.getFormatedNumber(element.eaUnits) | number}}</span>
              </div>
            </div>
            -->
            <div *ngIf="column=='dealerUnit'" class="text-center ">
              <div class="d-block d-md-none padding-l5">Dealer Order Units</div>
              <div>
                <button *ngIf="(!isReadOnly && !accessTypeMode) && (element.isProductDeactivated == undefined || element.isProductDeactivated === false || (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'partial')) && (element.dealerUnits >= 0)" (click)="dealerUnitChange('decrease',element);element.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.itemNumber"> - </button>

                <input *ngIf="element.dealerUnits >= 0"
                       [matTooltip]="element.originalDealerUnits ? 'Dealer Order Units Original ' + (element.originalDealerUnits | number) : ''"
                       [matTooltipPosition]="'above'"
                       matTooltipClass="seed-quantitiy-tooltip"
                       [readonly]="isReadOnly || accessTypeMode || (element.isProductDeactivated === true && element.deactivationType.trim().toLowerCase() != 'partial')"
                       type="text"
                       class="geu-txt unitsText"
                       id="txtUnits"
                       [(ngModel)]="element.dealerUnits"
                       (focus)="validateSelectedCount(element)"
                       maxlength="5"
                       NumbersOnly
                       (focusout)="validateLineItem(element,'dealerUnit','focusout')"
                       [attr.data-testid]="'qty-' + element.itemNumber" />
                <div *ngIf="element.dealerUnits < 0" class="text-center unitsText">
                  <span> ({{element.dealerUnits | positiveValue | number}})</span>
                </div>
                <button (mouseover)="blockHideShowPlus(element.rowId, true)" (mouseout)="blockHideShowPlus(element.rowId, false)" *ngIf="(!isReadOnly && !accessTypeMode) && (element.isProductDeactivated == undefined || element.isProductDeactivated === false || (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'partial')) && (element.dealerUnits >= 0)"
                        (click)="dealerUnitChange('increase',element);element.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.itemNumber">
                  +
                </button>
              </div>
            </div>
          </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
              <div class="warningMsg" *ngIf="element.showCutCancelOverWarning">
                <div class="row">
                  <div class="col-md-12">
                    {{cutCancelCancellationMessage}}
                  </div>
                </div>
              </div>
              <div class="newlineMsg" *ngIf="element.dealerOrderItemId == 0 && element.ChangeType == 'ADD'">
                <div class="row">
                  <div class="col-md-9 col-lg-10">
                    <p>
                    </p>
                  </div>
                  <div class="col-md-3 col-lg-2 text-right newitem">
                    <p>
                      New Line Item
                    </p>
                  </div>
                </div>
              </div>

              <!--<div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="product-detail-info-outer" *ngIf='element.selected == "product"' [ngClass]="{'prodDetailWithUnit': element.selected == 'product' && element.isSelected == true}">
                <div class="product-detail-info">
                  <span class="arrowTip productTip">
                    <i class="fas fa-sort-up"></i>
                  </span>
                  <table>
                    <thead>
                      <th class="text-left itemID">Item#</th>
                      <th class="text-left seedSize">Seed Size</th>
                      <th class="text-left treatment">Treatment</th>
                      <th class="text-left packageSize">Package Size</th>
                      <th class="text-left technology">Technology</th>
                      <th class="text-center prodLine">Product Line</th>
                      <th class="text-center maturity">Maturity</th>
                      <th class="text-center marketingBrand">Marketing Brand</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="productName text-left">{{element.itemNumber}}</td>
                        <td class="text-left">{{element.seedSize}}</td>
                        <td class="text-left">
                          <span [ngClass]="{'oval-shape treatment': (element.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'">
                            {{element.treatment}}
                          </span>
                        </td>
                        <td class="text-left">
                          <span [ngClass]="{'oval-shape pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'">
                            {{element.packageSize}}
                          </span>
                        </td>
                        <td class="text-left">
                          <span [ngClass]="{'oval-shape technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'">
                            {{element.technology}}
                          </span>
                        </td>
                        <td class="text-center">{{element.productLine}}</td>
                        <td class="text-center">{{element.maturity}}</td>
                        <td class="text-center">{{element.marketingBrand}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>-->

              <div class="row padding-t15 padding-b15 margin-l20 margin-r20 countBlock justify-content-center" [style.display]="element.isSelected ? 'flex' : 'none'">
                <div class="" [ngClass]="isEaUnitsEligible ? 'addBg':'addBgCanada'">
                  <p>Grower Units</p>
                  <p class="fontSize fontColor">{{commonService.getFormatedNumber(element.netGEU) | number}}</p>
                </div>
                <div class="" [ngClass]="isEaUnitsEligible ? 'addBg':'addBgCanada'">
                  <p>Dealer Units</p>
                  <p class="fontSize">{{element.netBEU | number}}</p>
                </div>

                <!--<div *ngIf="isEaUnitsEligible" class="d-none d-md-block" [ngClass]="isEaUnitsEligible ? 'addBg':'addBgCanada'">
                  <p>EA Modifiable Units</p>
                  <div class="DMU fontSize">
                    <span *ngIf="element.eaModifiableUnits >= 0" [ngbPopover]="eapopContent" [popoverTitle]="eapopTitle" triggers="mouseenter:mouseleave" class="handCursor fontSize fontColor">
                      {{element.eaModifiableUnits | number}}
                    </span>
                    <span *ngIf="element.eaModifiableUnits < 0" [ngbPopover]="eapopContent" [popoverTitle]="eapopTitle" triggers="mouseenter:mouseleave" class="handCursor fontSize fontColor">
                      0
                    </span>
                    <ng-template #eapopContent>
                      <div class="PopOverContent">
                        <div class="row">
                          <div class="col-md-6">Shipped:</div>
                          <div class="col-md-6 text-right bold">
                            <span *ngIf="element.eaShippedUnits >= 0" class="hoverDMU">
                              {{element.eaShippedUnits}}
                            </span>
                            <span *ngIf="element.eaShippedUnits < 0" class="hoverDMU">
                              0
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">Planned:</div>
                          <div class="col-md-6 text-right bold">
                            <span *ngIf="element.eaPlannedUnits >= 0" class="hoverDMU">
                              {{element.eaPlannedUnits}}
                            </span>
                            <span *ngIf="element.eaPlannedUnits < 0" class="hoverDMU">
                              0
                            </span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #eapopTitle>
                      <div class="row">
                        <div class="col-md-8">EA Modifiable Units</div>
                        <span class="col-md-4 text-right hoverDMU" *ngIf="element.eaModifiableUnits >= 0">{{element.eaModifiableUnits | number}}</span>
                        <span class="col-md-4 text-right hoverDMU" *ngIf="element.eaModifiableUnits < 0">0</span>
                      </div>
                    </ng-template>
                  </div>
                </div>-->

                <div class="" [ngClass]="isEaUnitsEligible ? 'addBg':'addBgCanada'">
                  <p>Dealer Modifiable Units</p>
                  <div class="DMU fontSize">
                    <span *ngIf="element.dealerModifiableUnits>=0" [ngbPopover]="popContent" [popoverTitle]="popTitle" triggers="mouseenter:mouseleave" class="handCursor fontSize fontColor">
                      {{element.dealerModifiableUnits | number}}
                    </span>
                    <span *ngIf="element.dealerModifiableUnits<0" [ngbPopover]="popContent" [popoverTitle]="popTitle" triggers="mouseenter:mouseleave" class="handCursor fontSize fontColor">
                      ({{element.dealerModifiableUnits | positiveValue | number}})
                    </span>

                    <ng-template #popContent>
                      <div class="PopOverContent">
                        <div class="row">
                          <div class="col-md-6">Shipped:</div>
                          <div class="col-md-6 text-right bold">
                            <span *ngIf="element.shippedUnits >= 0" class="hoverDMU">
                              {{element.shippedUnits-element.stockTransferUnits}}
                            </span>
                            <span *ngIf="element.shippedUnits < 0" class="hoverDMU">
                              ({{(element.shippedUnits-element.stockTransferUnits) | positiveValue | number}})
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">Planned:</div>
                          <div class="col-md-6 text-right bold">
                            <span *ngIf="element.plannedUnits >= 0" class="hoverDMU">
                              {{element.plannedUnits}}
                            </span>
                            <span *ngIf="element.plannedUnits < 0" class="hoverDMU">
                              ({{element.plannedUnits | positiveValue | number}})
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">Transferred:</div>
                          <div class="col-md-6 text-right bold">
                            <span *ngIf="element.stockTransferUnits >= 0" class="hoverDMU">
                              {{element.stockTransferUnits}}
                            </span>
                            <span *ngIf="element.stockTransferUnits < 0" class="hoverDMU">
                              ({{element.stockTransferUnits | positiveValue | number}})
                            </span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #popTitle>
                      <div class="row">
                        <div class="col-md-8">Dealer Modifiable Units</div>
                        <span class="col-md-4 text-right hoverDMU" *ngIf="element.dealerModifiableUnits>=0">{{element.dealerModifiableUnits | number}}</span>
                        <span class="col-md-4 text-right hoverDMU" *ngIf="element.dealerModifiableUnits<0">{{element.dealerModifiableUnits | positiveValue | number}}</span>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <div class="" [ngClass]="isEaUnitsEligible ? 'addBg':'addBgCanada'">
                  <p>My Dealer Bucket</p>
                  <p class="fontSize">
                    <span *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                    <span *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
                  </p>
                </div>
                <!--<div *ngIf="element.eaModifiableUnits > 0 && element.isItemInInclusion && element.isLessDealerUnits" style="padding: inherit;">
                  <mat-checkbox class="custom-checkbox margin-l10 reduce-ea-checkbox"
                                title="Reduce EA Modifiable Units" [(ngModel)]="element.isEaReducedModifiableChecked" (change)="validateEaReducedUnitChange(element)"></mat-checkbox>
                  <span class="padding-t20 padding-md-t0">Reduce EA Modifiable Units</span>
                </div>-->
              </div>


              <div class="prodExpendBlock">
                <mat-accordion>
                  <mat-expansion-panel (opened)="getDealerGrowerDetail(element)" hideToggle #growerDetailsExpend class="expansionPanel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Grower Details
                      </mat-panel-title>

                      <span *ngIf="!growerDetailsExpend.expanded" class="showHideicons float-r"><i class=" icon-ico-Plus"></i></span>
                      <span *ngIf="growerDetailsExpend.expanded" class="showHideicons float-r"><i class="icon-ico-Minus"></i></span>
                    </mat-expansion-panel-header>

                    <div class="detailsTableSec">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col" width="50%;">Grower</th>
                            <th scope="col" class="text-center" width="25%;">Grower Units</th>
                            <th scope="col" width="25%;" class="text-right">
                              &nbsp;
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let grower of element?.growerOrderInfoVM | slice: 0:element.totalRows">
                            <td>
                              <h4 class="name greenColor"> {{grower?.growerName}} </h4>
                              <p class="address">  {{grower?.address}}, {{grower?.city}}, {{grower?.state}} {{grower?.zipcode}} </p>
                            </td>
                            <td class="text-center">
                              <p class="">{{commonService.getFormatedNumber(grower?.primaryQuantity) | number}}</p>
                            </td>
                            <td class="text-right orderId-detail">
                              <span class="erp-order" *ngIf="grower?.orderType != 'WB'">
                                <i class="fas fa-lock"></i>
                              </span>
                              Order:
                              <p class="" (click)="navigateToGrowerOrder(grower)">{{grower?.orderNumber}}</p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td class="text-right" colspan="2">
                              <div class="tableFooter">
                                <span class="grower-total">
                                  Grower Totals: {{element?.growerOrderInfoVM?.length}}
                                </span>
                                <button mat-raised-button class="btns" color="primary" [disabled]="!element?.growerOrderInfoVM?.length || element.totalRows >= element?.growerOrderInfoVM?.length" (click)="element.totalRows = element?.growerOrderInfoVM?.length">View All</button>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                <div class="row">
                  <div class="col-md-9">
                    <ol class="error-list">
                      <li *ngFor="let err of element.lineErrors.errors">
                        {{err.error}}
                    </ol>
                  </div>
                  <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                    <span>
                      Revert to Previous.
                      <i class="icon-ico-Reply"></i>
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="groupHeader">
            <td *matCellDef="let group" [attr.colspan]="columnsToDisplay.length" class="groupName">Product orders for {{group.productLine}}</td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup" class="d-table-row"> </tr>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true;" class="d-none d-md-table-row"></tr>
          <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              [ngClass]="element?.itemNumber ? 'displayRow' : 'd-none'"
              (click)="expandedElement = expandedElement === element ? null : element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [style.display]="row?.itemNumber ? 'table-row' : 'none'"></tr>
          </table>
          <div *ngIf="totalProduct == 0" class="emptyDealerBlock d-block d-md-none">
            <div class="row padding-10">
              <div class="col-4 text-center">Product</div>
              <div class="col-4 text-center"></div>
              <div class="col-4 text-center"></div>
              <div class="col-4 text-center">Available Units</div>
              <div class="col-4 text-center">Long/(Short)</div>
              <div class="col-4 text-center">Dealer Order Units</div>
            </div>
          </div>
          <div class="tableTotalsSec">
            <div class="row">
              <div class="col-4 col-md-8 padding-l55 padding-sm-l15">Product Totals:</div>
              <div class="col-4 col-md-3 text-right padding-r70 padding-sm-r0">{{totalProduct}} Products</div>
              <div class="col-4 col-md-1 text-left padding-l0 padding-sm-l15">{{totalDealerUnits}} Bags</div>
            </div>
          </div>
        </div>

        <div class="common-error-block dealer-grower-order-detail" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors.length > 0">
          <div class="row">
            <div class="col-3 col-md-1 padding-r0 errCountOuter">
              <!--<span class="close-icon">
              <i class="icon-ico-Error"></i>
            </span>-->
              <span>
                {{currentErrorRow}} of {{errorMsgs.length}}
              </span>
            </div>
            <div class="col-9 col-md-7 padding-l0">
              <ol class="error-list">
                <li *ngFor="let err of errorMsgs[index].errors">
                  {{err.error}}
                </li>
              </ol>
            </div>
            <div class="col-md-4 button-sec text-right">
              <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
              <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row saveBtnsSec" *ngIf="!IsMobile && hasChangeAdded">
      <div class="col-md-12">
        <span *ngIf="addUpdateOpr=='Add'">
          <button mat-raised-button class="btns submitBtns margin-r10 wide-sm-100 font-sm-14" color="primary" (click)="addDealerOrder()" [style.display]="isBusy ? 'none' : 'inline-block'">Place Order</button>
          <a (click)="CancelDealerOrder()" href="javascript:void(0)">Cancel </a>
        </span>
      </div>
      <div class="col-md-12">
        <span *ngIf="addUpdateOpr!='Add'">
          <button *ngIf="transferListToSubmit.length <= 0" mat-raised-button class="btns submitBtns margin-r10 wide-sm-100 font-sm-14"
                  color="primary" (click)="updateDealerOrder()" [disabled]="!hasChangeAdded"
                  [style.display]="isBusy ? 'none' : 'inline-block'">
            Update Order
          </button>
          <button *ngIf="transferListToSubmit.length > 0" mat-raised-button class="btns  submitBtns margin-r10 wide-sm-100 font-sm-14"
                  color="primary" (click)="transferDealerOrder()" [disabled]="isUpdateButtonDisabled"
                  [style.display]="isBusy ? 'none' : 'inline-block'">
            Update Order
          </button>
          <a (click)="CancelDealerOrder()" href="javascript:void(0)">Cancel </a>
          <p class="warningMsg" *ngIf="showWarningOnUpdateButton">If you are canceling or reducing this seed item, it could result in a cancellation fee that will be assessed on a future invoice. If you have questions, please contact WinField United Customer Service at 1-855-494-6343.</p>
        </span>
      </div>
    </div>
    <div class="row saveBtnsSec" *ngIf="IsMobile">
      <div class="col-md-12 p-0 btnSection" *ngIf="addUpdateOpr=='Add'">
        <div class="d-md-block d-flex justify-content-between">
          <button mat-raised-button class="btns submitBtns margin-r10 font-sm-14" color="primary" (click)="backToOrder()" [style.display]="isBusy ? 'none' : 'inline-block'" [disabled]="hasChangeAdded">Back</button>
          <button *ngIf="hasChangeAdded" mat-raised-button class="btns submitBtns font-sm-14" color="primary" (click)="addDealerOrder()" [style.display]="isBusy ? 'none' : 'inline-block'">Place Order</button>
        </div>
        <a *ngIf="hasChangeAdded" (click)="CancelDealerOrder()" href="javascript:void(0)">Cancel </a>
      </div>
      <div class="col-md-12 p-0 btnSection" *ngIf="addUpdateOpr!='Add'">
        <div class="d-md-block d-flex justify-content-between">
          <button mat-raised-button class="btns submitBtns margin-r10 font-sm-14" color="primary" (click)="backToOrder()" [style.display]="isBusy ? 'none' : 'inline-block'" [disabled]="hasChangeAdded">Back</button>
          <button *ngIf="hasChangeAdded && transferListToSubmit.length <= 0" mat-raised-button class="btns submitBtns font-sm-14"
                  color="primary" (click)="updateDealerOrder()" [disabled]="!hasChangeAdded"
                  [style.display]="isBusy ? 'none' : 'inline-block'">
            Update Order
          </button>
          <button *ngIf="hasChangeAdded && transferListToSubmit.length > 0" mat-raised-button class="btns submitBtns font-sm-14"
                  color="primary" (click)="transferDealerOrder()" [disabled]="isUpdateButtonDisabled"
                  [style.display]="isBusy ? 'none' : 'inline-block'">
            Update Order
          </button>
        </div>
        <a *ngIf="hasChangeAdded" (click)="CancelDealerOrder()" href="javascript:void(0)">Cancel </a>
        <p class="warningMsg" *ngIf="hasChangeAdded && showWarningOnUpdateButton">If you are canceling or reducing this seed item, it could result in a cancellation fee that will be assessed on a future invoice. If you have questions, please contact WinField United Customer Service at 1-855-494-6343.</p>
      </div>

    </div>
  </div>
</div>
